import { Link } from 'react-router-dom';
import './StaticPages.css';

export default function Terms() {
  return (
    <div className="static-page">
      <div className="static-container">
        <Link to="/register" className="static-back">&larr; Back to Sign Up</Link>
        <h1>Terms & Conditions</h1>
        <p className="static-date">Last updated: July 30, 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By creating an account and using bustisha SMM Panel ("the Service"), you agree to be bound by these Terms & Conditions. If you do not agree, do not use the Service.</p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>bustisha provides social media marketing (SMM) services including but not limited to followers, likes, comments, and views for various social media platforms. We act as a reseller of third-party SMM services.</p>
        </section>

        <section>
          <h2>3. User Responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the confidentiality of your account credentials</li>
            <li>Use the Service in compliance with all applicable laws and regulations</li>
            <li>Not use the Service for any illegal or unauthorized purpose</li>
            <li>Not attempt to manipulate, abuse, or exploit the Service</li>
          </ul>
        </section>

        <section>
          <h2>4. Payments & Refunds</h2>
          <p>All payments are processed through mobile money services. Once an order is placed and processed, refunds are issued solely at the discretion of bustisha. Chargebacks or disputes may result in immediate account suspension.</p>
        </section>

        <section>
          <h2>5. Service Delivery</h2>
          <p>Delivery times vary depending on the service and quantity ordered. While we strive to deliver promptly, we do not guarantee specific delivery timelines. We are not responsible for drops, losses, or changes in social media platform algorithms that may affect order delivery.</p>
        </section>

        <section>
          <h2>6. Account Termination</h2>
          <p>We reserve the right to suspend or terminate accounts that violate these terms, engage in fraudulent activity, or for any other reason at our sole discretion.</p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>bustisha shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service. Our total liability is limited to the amount you have paid us in the 30 days preceding the claim.</p>
        </section>

        <section>
          <h2>8. Changes to Terms</h2>
          <p>We may modify these terms at any time. Continued use of the Service after changes constitutes acceptance of the new terms. You are responsible for reviewing these terms periodically.</p>
        </section>

        <section>
          <h2>9. Contact</h2>
          <p>For questions about these terms, please contact our support team through the ticket system or via WhatsApp.</p>
        </section>
      </div>
    </div>
  );
}
